import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center justify-center w-16 h-16 bg-primary rounded-xl shadow-soft-lg">
          <Icon name="Calculator" size={32} color="white" />
        </div>
      </div>

      {/* Title and Description */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-text-primary">
          KitchenQuote Pro
        </h1>
        <p className="text-lg text-text-secondary">
          Système de gestion des devis cuisine
        </p>
        <p className="text-sm text-text-secondary max-w-sm mx-auto">
          Connectez-vous pour accéder à votre espace de gestion des devis et de la base clients
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;